import Header from "./Header";
import Footer from "./Footer";
import { useApi, useIsMobile } from "../hooks";
import MobileHeader from "./MobileHeader";
import useLayoutStyles from "./Layout.style";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import AIClimateAssistant from "../pages/AIClimateAssistant";
import GlobalSearch from "../pages/GlobalSearch";
import { getCountryList, getSearchResults } from "../services";
import { useDispatch, useSelector } from "react-redux";
import { setOpenSearchPage } from "../store/slices/GlobalSearchSlice";
import { RootState } from "../store";
import { Button } from "@fluentui/react-components";
import { ArrowUp20Filled } from "@fluentui/react-icons";

export interface SearchResult {
  search_Result: {
    pageName: string;
    result: {
      heading: string;
      text: string;
    }[];
  }[];
  pagination: {
    page: number;
    pageSize: number;
    totalPages: number;
    totalRecords: number;
  };
}

const Layout = ({ children }: { children: React.ReactNode }) => {
  const styles = useLayoutStyles();
  const isMobile = useIsMobile();
  const location = useLocation();
  const dispatch = useDispatch();

  const {
    data: searchResults,
    execute: triggerSearchApi,
    loading: searchLoading,
  } = useApi(getSearchResults, { autoFetch: false });
  const { data: countryList } = useApi(getCountryList);

  const { openSearchPage } = useSelector(
    (state: RootState) => state.globalSearch
  );
  const { isExpanded } = useSelector(
    (state: RootState) => state.climateAssistant
  );

  const [searchResponse, setSearchResponse] = useState<SearchResult>(
    {} as SearchResult
  );

  useEffect(() => {
    if (searchResults) {
      dispatch(setOpenSearchPage(true));
      setSearchResponse(searchResults);
    }

    //eslint-disable-next-line
  }, [searchResults]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location.pathname]);

  return (
    <div className={styles.layout}>
      {isMobile ? (
        <MobileHeader triggerSearchApi={triggerSearchApi} />
      ) : (
        <Header triggerSearchApi={triggerSearchApi} />
      )}

      <div
        style={{
          display: isMobile ? (isExpanded ? "none" : "block") : "block",
        }}
      >
        {!openSearchPage ? (
          <>
            <main className={styles.main}>{children}</main>
            <Footer />
          </>
        ) : (
          <GlobalSearch
            triggerSearchApi={triggerSearchApi}
            searchResults={searchResponse}
            countryList={countryList}
            searchLoading={searchLoading}
          />
        )}
      </div>

      {!isExpanded && isMobile && (
        <Button
          appearance="transparent"
          icon={<ArrowUp20Filled />}
          className={styles.backToTopBtn}
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        >
          Back to top
        </Button>
      )}

      <AIClimateAssistant />
    </div>
  );
};

export default Layout;
